// initial state
const state = () => ({
  packages: [],
  timer: null,
  voucher: null,
  selectedPackage: null,
  cid: null,
  ip: null,
});

// getters
const getters = {
  getPackages: state => {
    return state.packages;
  },
  getTimer: state => {
    return state.timer;
  },
  getSelectedPackage: state => {
    return state.selectedPackage;
  },
  getVoucher: state => {
    return state.voucher;
  },
  getCid: state => {
    return state.cid;
  },
  getIp: state => {
    return state.ip;
  },
};

// actions
const actions = {
  load({ commit }, unit = 'coin') {
    return axios
      .get(zRoute('ajax.payment.shop_package.index', {
        unit: unit,
        service: 'WEB',
      }))
      .then((response) => {
        commit('setPackages', response.data.data);
        commit('setTimer', response.data.timer);
      })
      .catch(() => {
        return false;
      });
  },
};

// mutations
const mutations = {
  setPackages: (state, packages) => {
    state.packages = packages;
  },
  setTimer: (state, timer) => {
    state.timer = timer;
  },
  setVoucher: (state, voucher) => {
    state.voucher = voucher;
  },
  setSelectedPackage: (state, selectedPackage) => {
    state.selectedPackage = selectedPackage;
  },
  setCid: (state, cid) => {
    state.cid = cid;
  },
  setIp: (state, ip) => {
    state.ip = ip;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
